import React from 'react'

export default function Loader() {
    return (
        <div className="loading-wrapper">
            <div className="loading"></div>
        </div>
    )
}



